import crash from 'public/static/images/404-crash.gif';
import { screen, colors } from 'components/styles/variables';
import css from 'styled-jsx/css';

export default css`
  color: white;

  @media screen and (max-width: ${screen.xsMax}) {
    height: 450px;
  }

  .content {
    color: white;
    position: relative;
    top: -540px;
  }

  .content .row {
    margin-left: 0;
    margin-right: 0;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .content .row {
      margin-left: -15px;
      margin-right: -15px;
    }
  }

  @media screen and (max-width: ${screen.xsMax}) {
    .content {
      top: -450px;
    }
  }

  h1 {
    position: absolute;
    top: 67px;
    width: 90%;
    line-height: 53px;
    font-size: 52px;
    font-weight: 600;
  }

  @media screen and (max-width: ${screen.xsMax}) {
    h1 {
      top: 42px;
      line-height: 42px;
      font-size: 40px;
    }
  }

  p {
    position: absolute;
    top: 206px;
    width: 90%;
    line-height: 28px;
    font-size: 25px;
    color: white;
  }

  @media screen and (max-width: ${screen.xsMax}) {
    p {
      top: 165px;
      line-height: 30px;
      font-size: 26px;
    }
  }

  .button-container {
    position: absolute;
    top: 370px;
  }

  @media screen and (max-width: ${screen.xsMax}) {
    .button-container {
      top: 300px;
    }
  }

  .button-container .button {
    color: white;
    border: 2px solid white;
    border-radius: 30px;
    text-transform: none;
    text-align: center;
    text-decoration: none;
    font-size: 17px;
    font-weight: 600;
    padding: 12px 50px;
    cursor: pointer;
    background-color: initial;
  }

  button-container .button:hover,
  button-container .button:active {
    background-color: white;
    background-color: ${colors.ALR1};
    transition: 1s all ease;
  }

  .background {
    height: 540px;
    width: 100%;
    background: url(${crash});
    background-size: 1500px 840px;
    background-position: center -80px;
  }

  @media screen and (max-width: ${screen.xsMax}) {
    .background {
      background-position: 56% 0;
      background-size: 1000px 560px;
      height: 450px;
    }
  }

  .background .overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(242, 9, 2, 0.7);
  }

  .outer-container {
    width: 100vw;
    align-self: center;
  }
`;
